import { render, staticRenderFns } from "./RendPositionsCloseTrade.vue?vue&type=template&id=21bf4adf&"
import script from "./RendPositionsCloseTrade.vue?vue&type=script&lang=js&"
export * from "./RendPositionsCloseTrade.vue?vue&type=script&lang=js&"
import style0 from "./RendPositionsCloseTrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports